module.exports = __webpack_public_path__ + "static/media/shop-amazing.b8c7e4b6.png";